import React from 'react'
import { Icon as IconifyIcon } from '@iconify/react'
import { useI18n } from '../lib/i18n'

export default function Footer() {
  const currentYear = new Date().getFullYear()
  const { t } = useI18n()

  // Design System Colors
  // Background: #F4F5F7
  // Text: #172B4D
  // Primary Hover: #0052CC
  
  return (
    <footer className="bg-[#F4F5F7] relative z-20 border-t border-[#172B4D]/10 text-[#172B4D]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 md:py-16">
        {/* Main Grid Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-12">
          
          {/* Column 1: Brand & Mission */}
          <div className="flex flex-col items-start">
            <img
              src="/Logo.png"
              alt="Park-Box Frankfurt"
              className="h-8 w-auto mb-6"
            />
            <p className="text-sm leading-relaxed text-[#172B4D]/70 max-w-xs mb-6">
              {t.footer.description}
            </p>
            <div className="flex items-center gap-4">
              <a
                href="tel:+4917632655029"
                aria-label="Telefon"
                className="text-[#172B4D]/40 hover:text-[#0052CC] transition-colors"
              >
                <IconifyIcon icon="lucide:phone" width={20} />
              </a>
              <a
                href="mailto:info@parkboxfrankfurt.com"
                aria-label="E-Mail"
                className="text-[#172B4D]/40 hover:text-[#0052CC] transition-colors"
              >
                <IconifyIcon icon="lucide:mail" width={20} />
              </a>
            </div>
          </div>

          {/* Column 2: Service Navigation */}
          <div>
            <h3 className="text-xs font-bold tracking-wider uppercase text-[#172B4D] mb-6">
              {t.footer.service}
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="/valet-parken-frankfurt-flughafen" className="text-sm text-[#172B4D]/60 hover:text-[#0052CC] transition-colors block py-1">
                  {t.footer.parking}
                </a>
              </li>
              <li>
                <a href="/flughafen-frankfurt-preise" className="text-sm text-[#172B4D]/60 hover:text-[#0052CC] transition-colors block py-1">
                  {t.footer.prices}
                </a>
              </li>
              <li>
                <a href="/parkplatz-hattersheim-frankfurt-flughafen-anfahrt" className="text-sm text-[#172B4D]/60 hover:text-[#0052CC] transition-colors block py-1">
                  {t.footer.directions}
                </a>
              </li>
              <li>
                <a href="/stornierung" className="text-sm text-[#172B4D]/60 hover:text-[#0052CC] transition-colors block py-1">
                  {t.footer.cancelBooking}
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Unternehmen Navigation */}
          <div>
            <h3 className="text-xs font-bold tracking-wider uppercase text-[#172B4D] mb-6">
              {t.footer.company}
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="/kontakt-valet-parken-frankfurt" className="text-sm text-[#172B4D]/60 hover:text-[#0052CC] transition-colors block py-1">
                  {t.footer.contact}
                </a>
              </li>
              <li>
                <a href="/fragen-antworten-flughafenparkplatz-frankfurt" className="text-sm text-[#172B4D]/60 hover:text-[#0052CC] transition-colors block py-1">
                  {t.footer.faq}
                </a>
              </li>
              <li>
                <a href="/" className="text-sm text-[#172B4D]/60 hover:text-[#0052CC] transition-colors block py-1">
                  {t.footer.home}
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact Info */}
          <div>
            <h3 className="text-xs font-bold tracking-wider uppercase text-[#172B4D] mb-6">
              {t.footer.contactTitle}
            </h3>
            <div className="space-y-4">
              <a href="mailto:info@parkboxfrankfurt.com" className="flex items-center gap-2 text-sm text-[#172B4D]/70 hover:text-[#0052CC] transition-colors group">
                <IconifyIcon icon="ph:envelope-simple" width={18} className="text-[#172B4D]/50 group-hover:text-[#0052CC]" />
                info@parkboxfrankfurt.com
              </a>
              <div className="text-sm text-[#172B4D]/60 leading-relaxed">
                <p>{t.footer.locationInfo}</p>
                <p className="mt-1">{t.footer.hours}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar: Copyright & Legal */}
        <div className="pt-8 border-t border-[#172B4D]/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#172B4D]/40 text-center md:text-left">
            {t.footer.copyright.replace('{year}', String(currentYear))}
          </p>
          <div className="flex flex-wrap justify-center gap-6">
            <a href="/impressum" className="text-xs text-[#172B4D]/40 hover:text-[#0052CC] transition-colors">
              {t.footer.imprint}
            </a>
            <a href="/datenschutz" className="text-xs text-[#172B4D]/40 hover:text-[#0052CC] transition-colors">
              {t.footer.privacy}
            </a>
            <a href="/agb" className="text-xs text-[#172B4D]/40 hover:text-[#0052CC] transition-colors">
              {t.footer.terms}
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}